import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

interface CareMapprDropdownProps {
  label?: string;
  labelClassName?: string;
  options?: { label: string; value: any }[];
  multiSelect?: boolean;
  hasError?: boolean;
  value?: any;
  name?: string;
  onChange?: (value: any) => void;
  onReset?: () => void;
  placeholder?: string;
  controlId?: string;
  className?: string;
  margin?: '0' | '1' | '2' | '3' | '4' | '5';
  size?: number; // This will control input size indirectly via styles
  disabled?: boolean;
  formatOptionLabel?: (data: { label: string; value: any }) => React.ReactNode;
}

const CareMapprDropdown = ({
  label,
  labelClassName = '',
  options = [],
  multiSelect = false,
  hasError = false,
  value,
  onChange,
  onReset,
  name,
  placeholder = 'Select an option',
  controlId = 'dropdown',
  className = '',
  margin = '0',
  size = 800, // This can be used for custom styles
  disabled = false,
  formatOptionLabel,
}: CareMapprDropdownProps) => {
  const marginValue = 'm-' + margin;

  // Custom styles for the dropdown
  const customStyles = {
    control: (base: any) => ({
      ...base,
      maxWidth: `${size}px`,
      borderColor: hasError ? '#dc3545' : base.borderColor,
      '&:hover': {
        borderColor: hasError ? '#dc3545' : base.borderColor,
        boxShadow: hasError
          ? '0 0 0 0.2rem rgba(220,53,69,.25)'
          : base.boxShadow,
      },
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 1060,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 1060,
    }),
  };

  return (
    <Form.Group controlId={controlId} className={`${marginValue} ${className}`}>
      {label && (
        <Form.Label className={`ellipsis ${labelClassName}`}>
          {label}
        </Form.Label>
      )}
      <Select
        name={name}
        isMulti={multiSelect}
        options={options || []}
        placeholder={placeholder}
        onChange={onChange}
        value={value || null}
        isDisabled={disabled}
        styles={customStyles} // Apply custom styles
        formatOptionLabel={formatOptionLabel}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </Form.Group>
  );
};

export default CareMapprDropdown;
